"use client"
import { UserCircle, Pencil, ChevronDown } from "lucide-react"
import { useState } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Button } from "@/components/ui/button";
import {
  ChevronLeft,


} from "lucide-react";

export default function CompanyProfileForm() {
  const [image, setImage] = useState<string | null>(null);
  const [formData, setFormData] = useState({
    companyName: "",
    email: "",
    phone: "",
    category: "",
    address: "",
    country: "",
    province: "",
    city: "",
    citiesServed: "",
    postalCode: "",
    companyDescription: "",
    websiteUrl: "",
    facebookUrl: "",
    instagramUrl: "",
    youtubeUrl: "",
    linkedInUrl: "",
    xUrl: ""
  });

  const isFormValid =
    formData.companyName.trim() &&
    formData.email.trim() &&
    formData.phone.trim()
    &&
    formData.category.trim() &&
    formData.address.trim() &&
    formData.country.trim() &&
    formData.province.trim() &&
    formData.city.trim() &&
    formData.citiesServed.trim() &&
    formData.postalCode.trim();

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log("line 9")
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result as string); // Set the uploaded image as the source
      };
      reader.readAsDataURL(file);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };
  const handleSubmit = () => {
    console.log(formData, "line 44");
    // Example: axios.post('/api/save', formData)
  };

  return (
    <div className="mx-auto p-4 md:p-6 bg-white">
      <div className="mb-8 flex justify-start">
        <div className="relative">
          <div className="mb-5">
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button
                    variant="secondary"
                    className="flex items-center gap-x-1"
                    size="icon"
                    onClick={() => history.back()}
                  >
                    <ChevronLeft />
                  </Button>
                </TooltipTrigger>
                <TooltipContent>
                  <p>Go Back</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>

          </div>
          <div className="h-20 w-20 bg-gray-100 rounded-full flex items-center justify-center overflow-hidden">
            {/* Display uploaded image or default icon */}
            {image ? (
              <img src={image} alt="Profile" className="h-20 w-20 object-cover" />
            ) : (
              <UserCircle className="h-12 w-12 text-gray-500" />
            )}
          </div>
          <div className="absolute h-7 w-7 bottom-0 right-0 rounded-full border-2 border-white bg-green-500 flex items-center justify-center">
            <input
              type="file"
              // accept="image/*"
              accept="image/png, image/jpeg, image/jpg, image/gif, image/webp"
              onChange={handleImageChange}
              className="absolute inset-0 opacity-0"
            />
            <Pencil className="h-3.5 w-3.5 text-white" />
          </div>
        </div>
      </div>

      <form className="space-y-8">
        {/* Company Information */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="space-y-2">
            <label htmlFor="company-name" className="block text-sm font-medium text-gray-700">
              Company Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="companyName"
              placeholder="Enter Company Name"
              value={formData.companyName}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 "
            />

          </div>

          <div className="space-y-2">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              Email <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              id="email"
              placeholder="Enter Email Address"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 "
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
              Phone Number <span className="text-red-500">*</span>
            </label>
            <input
              type="tel"
              id="phone"
              placeholder="Enter Phone Number"
              value={formData.phone}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2"
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="category" className="block text-sm font-medium text-gray-700">
              Category <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <select
                id="category"
                className="appearance-none w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 "
                value={formData.companyName}
                onChange={handleChange}
                defaultValue=""
              >
                <option value="" disabled>
                  Select Categories
                </option>
                <option value="category1">Category 1</option>
                <option value="category2">Category 2</option>
                <option value="category3">Category 3</option>
              </select>
              <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" />
            </div>
          </div>

          <div className="space-y-2">
            <label htmlFor="address" className="block text-sm font-medium text-gray-700">
              Address <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="address"
              value={formData.address}
              placeholder="Enter Address"
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 "
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="country" className="block text-sm font-medium text-gray-700">
              Country <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <select
                id="country"
                className="appearance-none w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 "
                value={formData.country}
                onChange={handleChange}
                defaultValue=""
              >
                <option value="" disabled>
                  Select Country
                </option>
                <option value="canada">Cannda</option>
                <option value="united-states">United States</option>
              </select>
              <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" />
            </div>
          </div>

          <div className="space-y-2">
            <label htmlFor="province" className="block text-sm font-medium text-gray-700">
              Province/State <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <select
                id="province"
                className="appearance-none w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 "
                value={formData.province}
                onChange={handleChange}
                defaultValue=""
              >
                <option value="" disabled>
                  Select State
                </option>
                <option value="ontario">Ontario</option>
                <option value="quebec">Quebec</option>
                <option value="bc">British Columbia</option>
              </select>
              <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" />
            </div>
          </div>

          <div className="space-y-2">
            <label htmlFor="city" className="block text-sm font-medium text-gray-700">
              City <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="city"
              placeholder="Enter City"
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 "
              value={formData.city}
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="cities-served" className="block text-sm font-medium text-gray-700">
              Cities Served <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <select
                id="cities-served"
                className="appearance-none w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 "
                value={formData.citiesServed}
                onChange={handleChange}
                defaultValue=""
              >
                <option value="" disabled>
                  Select City
                </option>
                <option value="toronto">Toronto</option>
                <option value="vancouver">Vancouver</option>
                <option value="montreal">Montreal</option>
              </select>
              <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" />
            </div>
          </div>

          <div className="space-y-2">
            <label htmlFor="postal-code" className="block text-sm font-medium text-gray-700">
              Zip/Postal Code <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="postal-code"
              placeholder="Enter Zip/Postal Code"
              value={formData.postalCode}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 "
            />
          </div>
        </div>

        <div className="space-y-2">
          <label htmlFor="description" className="block text-sm font-medium text-gray-700">
            Company Description <span className="text-red-500">*</span>
          </label>
          <textarea
            id="description"
            placeholder="Enter Description"
            value={formData.companyDescription}
            // onChange={handleChange}

            rows={5}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 "
          ></textarea>
        </div>

        {/* Contact Information */}
        <div>
          <h2 className="text-lg font-semibold mb-4">Contact Information</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="space-y-2">
              <label htmlFor="website" className="block text-sm font-medium text-gray-700">
                Website
              </label>
              <input
                type="url"
                id="website"
                placeholder="Enter Website"
                value={formData.websiteUrl}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 "
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="facebook" className="block text-sm font-medium text-gray-700">
                Facebook URL
              </label>
              <input
                type="url"
                id="facebook"
                placeholder="Enter Facebook URL"
                value={formData.facebookUrl}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 "
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="instagram" className="block text-sm font-medium text-gray-700">
                Instagram URL
              </label>
              <input
                type="url"
                id="instagram"
                placeholder="Enter Instagram URL"
                value={formData.instagramUrl}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 "
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="youtube" className="block text-sm font-medium text-gray-700">
                YouTube URL
              </label>
              <input
                type="url"
                id="youtube"
                placeholder="Enter YouTube URL"
                value={formData.youtubeUrl}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 "
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="linkedin" className="block text-sm font-medium text-gray-700">
                LinkedIn URL
              </label>
              <input
                type="url"
                id="linkedin"
                placeholder="Enter LinkedIn URL"
                value={formData.linkedInUrl}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 "
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="x-url" className="block text-sm font-medium text-gray-700">
                X URL
              </label>
              <input
                type="url"
                id="x-url"
                placeholder="Enter X URL"
                value={formData.xUrl}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 "
              />
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end space-x-4">
          <button
            type="button"
            className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 "
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className={`px-6 py-2 rounded ${isFormValid
              ? "bg-green-500 text-white"
              : "bg-gray-300 text-gray-600 cursor-not-allowed"
              }`}
            disabled={!isFormValid}
          >
            Save Details
          </button>

        </div>
      </form>
    </div>
  )
}
